import { useEffect } from "react";
import { useAppDispatch } from "../redux/typedHooks";
import { setUser } from "../redux/modules/userSlice";
import { usePersonalInfoQuery } from "../query";
import { UserInterface } from "../types/user";

/**
 * Глобальна інформація юзера з одного кешу personal-info (React Query).
 * staleTime 5 хв, dedupe. Результат синхронізується в Redux для зворотної сумісності.
 */
export const useGlobalUserInfo = () => {
  const dispatch = useAppDispatch();
  const { data: userData, isSuccess } = usePersonalInfoQuery();

  useEffect(() => {
    if (isSuccess && userData) {
      dispatch(setUser({ ...userData } as UserInterface));
    }
  }, [dispatch, isSuccess, userData]);

  return userData
};
